import { Session } from "@/redux/_session.types"
import { createSelector } from "@reduxjs/toolkit"

const sessionState = (state: { _session: Session }) => state

export const selectSession = createSelector(sessionState, (state) => state._session)
